import { Fragment, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import * as infotextsApi from '../api/Infotexts';
import { IInfoTextDetails } from '../util/DataModelInterface';
import { Spinner } from './Spinner';
import useToastHandler from '../hooks/useToastHandler';
import { ToastWrap } from './ToastWrap';

const INFO_TEXTS = [
  'login.info.header',
  'login.info',
]

export const InfoTexts = () => {
    const intl = useIntl();
    const { addToast } = useToastHandler();

    const [infotextData, setInfotextData] = useState([] as IInfoTextDetails[]);
    const [loading, setLoading] = useState(false);
    const [toastActive, setToastActive] = useState(false);
    const [toastHeader, setToastHeader] = useState("");
    const [toastText, setToastText] = useState("");
    const [toastType, setToastType] = useState("");
    const [open, setOpen] = useState({} as {[x: number]: boolean});
    const [changedDetails, setChangedDetails] = useState({
      confirm: false,
      reminder: false,
      reminder2: false,
      periodOpen: false
    } as {[x: string]: boolean});

  useEffect(() => {
    setLoading(true);
    refreshData()
    .finally(() => {
      setLoading(false);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshData = async (force: boolean = false) => {
    await infotextsApi.getInfotexts(force).then((data: any) => {
      if (data?.error) {
        addToast(data.error, 'infotexts', 'fetch');
      } else if (data) {
        console.log("infotexts: ", data);
        setInfotextData(data);
      }
    });
  }

    const saveInfotext = async (text: string) => {

      setLoading(true);
      let temp = infotextData.find((item) => item.text_id === text ) as IInfoTextDetails;
      let resp = await infotextsApi.modifyInfotext(temp);
      if (resp?.error) {
        setToastHeader(intl.formatMessage({id: 'error.infotexts.save'}));
        setToastType('warning');
        setToastActive(true);
      } else {
        setSavedStates(text);
        await refreshData(true);
      }
      setLoading(false);
    }

    const toggleOneDetailSections = (index: number, e: any) => {
      if (open[index] !== e.target.open) {
          setOpen({...open, [index]: e.target.open});
      }
  }

  const update = (event: { currentTarget: any; }, infotext: string) => {

    const target = event.currentTarget;
    let newInfotextData = [...infotextData] as any;
    let infotextIndex = infotextData.findIndex((item) => item.text_id === infotext );
    let text = target.value;
    newInfotextData[infotextIndex][target.name] = text?.replaceAll('\n', '<br>\n');

    setChangedDetails({...changedDetails, [infotext]: true});
  }

  // Set states to saved
  const setSavedStates = (infotext: string) => {
    let newInfotextData = [...infotextData] as any;
    setInfotextData(newInfotextData);
    setToastHeader(intl.formatMessage({id: 'languages.infotext.saved'}));
    setToastText("");
    setToastType('success');
    setToastActive(true);

    setChangedDetails({...changedDetails, [infotext]: false});
  }

  const getInfotextItems = (infotext: string, tempIndex: number) => {
    let temp = infotextData.find((item) => item.text_id === infotext );
    if (!temp){
      return null;
    }
    let text_fi = temp.text_fi ? temp.text_fi.replaceAll('<br>\n', '\n') : "";
    let text_se = temp.text_se ? temp.text_se.replaceAll('<br>\n', '\n') : "";
    let text_en = temp.text_en ? temp.text_en.replaceAll('<br>\n', '\n') : "";
      return (
        <Fragment key={tempIndex}>
          <details open={open[tempIndex]} onToggle={(event) => toggleOneDetailSections(tempIndex, event)}>
            <summary className={ changedDetails[infotext] ? "changed" : "" }>
              <h2>
                <FormattedMessage id={"languages.infotexts." + infotext}/>
              </h2>
            </summary>
            <div className="details-content">

              <fieldset>
                <legend><FormattedMessage id="languages.finnish"/></legend>
                <div className="form-group">
                  <label htmlFor="text_fi" className="form-label"><FormattedMessage id="languages.infotext.content"/></label>
                  <textarea id="text_fi" name="text_fi" rows={5} style={{whiteSpace: 'pre'}}
                    autoComplete="off" onChange={(e) => update(e, infotext)}
                    className={"form-control"} value={text_fi}></textarea>
                </div>
              </fieldset>

              <fieldset>
                <legend><FormattedMessage id="languages.swedish"/></legend>
                <div className="form-group">
                  <label htmlFor="text_se" className="form-label"><FormattedMessage id="languages.infotext.content"/></label>
                  <textarea id="text_se" name="text_se" rows={5}
                    autoComplete="off" onChange={(e) => update(e, infotext)}
                    className={"form-control"} value={text_se}></textarea>
                </div>
              </fieldset>

              <fieldset>
                <legend><FormattedMessage id="languages.english"/></legend>
                <div className="form-group">
                  <label htmlFor="text_en" className="form-label"><FormattedMessage id="languages.infotext.content"/></label>
                  <textarea id="text_en" name="text_en" rows={5} style={{whiteSpace: 'pre'}}
                    autoComplete="off" onChange={(e) => update(e, infotext)}
                    className={"form-control"} value={text_en}></textarea>
                </div>
              </fieldset>

            </div>

            <div className="form-buttons">
              <button type="button" className="btn btn-primary btn-save" disabled={!changedDetails[infotext]}
                onClick={(e) => saveInfotext(infotext)}>
                <i className="fa fa-save me-2" aria-hidden="true"></i>
                <FormattedMessage id="button.save"/>
              </button>
            </div>

          </details>
        </Fragment>
      )
  }

    return (
      <div id="tab-tabpane-infotexts" role="tabpanel" aria-labelledby="tab-tab-infotexts">
        <Spinner active={loading} />
        <ToastWrap active={toastActive} heading={toastHeader} text={toastText} type={toastType} setActive={(active: boolean) => setToastActive(active)} />
        <div className="alert alert-info"><i className="fa fa-info-circle mr-2"></i>
          <div>
            <p><FormattedMessage id="languages.infotexts.usage"/></p>
          </div>
        </div>
        <div id="infotextsList">

        {INFO_TEXTS.map((infotext, index) =>
          getInfotextItems(infotext, index))}

        </div>
      </div>
    );
};